import clsx from 'clsx';
import { Link } from 'react-router-dom';
import { Column, selectableColumn } from '../../../../components';
import { IconButton } from '../../../../components/controls';
import KeyActions from '../../components/KeyActions';
import PulseKey from '../../store/PulseKey';
import PulseKeySearch from '../../store/PulseKeySearch';
import classes from './createColumns.module.scss';

export default function createColumns(
  search: PulseKeySearch,
): Column<PulseKey>[] {
  return [
    selectableColumn(),
    {
      header: 'Pulse Key',
      id: 'key',
      renderCell(pulseKey, column) {
        return (
          <td className={clsx(classes.keyCell, column.classes)} key={column.id}>
            <Link to={`/pulse-keys/${pulseKey.key}`}>{pulseKey.key}</Link>
            <IconButton
              className={classes.copyKey}
              color="default"
              icon="copy"
              onClick={pulseKey.copyToClipboard}
              size="small"
              title="Copy the key to the clipboard"
            />
          </td>
        );
      },
    },
    {
      header: 'Product',
      id: 'sellableId',
      renderCell(pulseKey) {
        return search.getSellableDisplayName(pulseKey.sellableId);
      },
    },
    {
      header: 'SKU',
      id: 'sku' as any,
      renderCell(pulseKey) {
        return search.getSellableSku(pulseKey.sellableId);
      },
      visible: search.columns.sku,
    },
    {
      header: 'Creation date',
      id: 'createdAt',
      format: 'time',
      visible: search.columns.createdAt,
    },
    {
      header: 'Customer',
      id: 'customerEmail',
      orderBy: 'redemptionEmail',
    },
    {
      header: 'Redemption Time',
      id: 'redeemedAt',
      format: 'date',
    },
    {
      header: 'Status',
      id: 'status',
      visible: search.columns.status,
    },
    {
      header: 'Label',
      id: 'label',
      visible: search.columns.label,
    },
    {
      header: 'Number of Downloads',
      id: 'downloadCount',
      visible: search.columns.downloadCount,
    },
    {
      header: 'IP of redemption',
      id: 'redemptionIp',
      orderBy: false,
      visible: search.columns.redemptionIp,
    },
    {
      header: 'IP of download',
      id: 'ipOfDownload',
      orderBy: false,
      visible: search.columns.ipOfDownload,
    },
    {
      header: 'Sent date',
      id: 'fulfilledAt',
      visible: search.columns.fulfilledAt,
      format: 'date',
    },
    {
      header: '',
      id: 'actions' as any,
      orderBy: false,
      renderCell(pulseKey, column) {
        return (
          <td
            className={clsx(classes.actionCell, column.classes)}
            key={column.id}
          >
            <KeyActions onChange={search.search} pulseKey={pulseKey} />
          </td>
        );
      },
    },
  ];
}
